var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.path ? 'DcwLink' : _vm.as,{tag:"component",class:("dcw-tooltip dcw-tooltip--" + _vm.direction + " dcw-tooltip--" + _vm.color),attrs:{"path":_vm.path}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }